const flatten = require('lodash/flatten');
const cloneDeep = require('lodash/cloneDeep');
const appConfig = require('./config/app.conf');

const routes = [
  {
    path: '/',
    component: 'pages/Home',
  },
  {
    path: '/thank-you',
    component: 'pages/ThankYou',
  },
  {
    path: '/pcf',
    component: 'pages/PCF',
  },
  {
    path: '/email',
    component: 'pages/Email/Email',
  },
  {
    path: '/pcform',
    component: 'pages/PCForm/PCForm',
  },
  {
    path: '/dr',
    component: 'pages/DR/DR',
  },
  {
    path: '/thankyou',
    component: 'pages/ThankYou/ThankYou',
  },
  {
    path: '/reg-home-selection-start',
    component: 'pages/HomeSelectionForm/HomeSelectionStart',
  },
  {
    path: '/reg-home-selection-form',
    component: 'pages/HomeSelectionForm/HomeSelectionForm',
  },
  {
    path: '/vhome-selection-start',
    component: 'pages/HomeSelectionForm/HomeSelectionStartVIP',
  },
  {
    path: '/vhome-selection-form',
    component: 'pages/HomeSelectionForm/HomeSelectionFormVIP',
  },
  {
    path: '/home-selection-complete',
    component: 'pages/ThankYou/ThankYouSubmission',
  },
  {
    path: '/home-selection-dr',
    component: 'pages/HomeSelectionForm/HomeSelectionDR',
  },
  {
    path: '/consent-to-ds-form',
    component: 'pages/HomeSelectionForm/ConsentDS',
  },
  {
    path: '/consent-to-ds-complete',
    component: 'pages/ThankYou/ThankYouSubmissionDS',
  },
  {
    path: '/additional-buyer-start',
    component: 'pages/HomeSelectionForm/AdditionalBuyerStart',
  },
  {
    path: '/additional-buyer-form',
    component: 'pages/HomeSelectionForm/AdditionalBuyerForm',
  },
  {
    path: '/additional-buyer-complete',
    component: 'pages/ThankYou/ThankYouSubmission',
  },
  {
    path: '/questionnaire',
    component: 'pages/Questionnaire/QuestionnaireForm',
  },
  {
    path: '/questionnaire-thankyou',
    component: 'pages/ThankYou/QuestionnaireThankYou',
  },
  // legal form TAB5
  {
    path: '/legal-representative-form',
    component: 'pages/LegalForm/LegalForm',
  },
  {
    path: '/legal-thank-you',
    component: 'pages/ThankYou/LegalThankYou',
  },
];

const generateRoutes = function () {
  let generatedRoutes = routes;
  let { locales } = appConfig;
  // If there is only one locale, that is the default and therefore does not
  // need to be considered.
  if (locales.length <= 1) {
    locales = [];
  }
  // Strip the default locale from the locale array. We don't need
  // to generate a prerendered path prefixed with the default locale.
  else {
    locales = locales.filter((locale) => locale !== appConfig.defaultLocale);
  }

  // Generate localized routes for each supported locale if there are multiple
  // supported locales.
  if (locales.length > 0) {
    let localizedRoutes = locales.map((locale) => {
      return cloneDeep(routes).map((route) => {
        route.path = `/${locale}${route.path}`;
        return route;
      });
    });
    // Merge the base routes and the localized routes.
    generatedRoutes = flatten(generatedRoutes.concat(localizedRoutes));
  }

  // Finally, add the wildcard route at the end to redirect to 404 page.
  generatedRoutes.push({
    path: '*',
    component: 'pages/NotFound',
  });

  return generatedRoutes;
};

module.exports = generateRoutes();
